import { SystemOfMeasurementOptions } from "@app/api/me/MeGetResponse"

export type MeasurementSystemState = {
  selectedMeasurementSystem: SystemOfMeasurementOptions;
}

export const measurementSystemInitialState: MeasurementSystemState = {
  selectedMeasurementSystem: SystemOfMeasurementOptions.Metric,
}